export const apiBaseURL = {
    USERS: "/users",
    ADMIN_LOGIN: "/auth/login",
    LOGOUT: "/logout",
    ADMIN_REGISTER: "/auth/register",
    INTEREST_RATES_DATA_TYPES: "/interest-rates-data-types",
    INTEREST_RATES_DATA_TYPES_ASSET: "/interest-rates-data-type-assets",
    ASSET_VALUE: "/asset-value",
    ASSET: "/assets",
    COUNTRIES: "/countries",
    CURRENCY: "/currency",
    PROFILE:'/profile',
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
}

export const Tokens = {
    ADMIN_TOKEN: 'auth_token',
    ADMIN: 'admin',
    ADMIN_ROLE: 'role'
};

export const authActionType = {
    LOGIN_ADMIN: 'LOGIN_ADMIN',
    LOGOUT: 'LOGOUT',
    REGISTER: 'REGISTER'
};

export const countryType = {
    FETCH_COUNTRIES: 'FETCH_COUNTRIES',
};

export const currencyType = {
    FETCH_CURRENCY: 'FETCH_CURRENCY',
};

export const ycrType = {
    FETCH_INTEREST_RATES_DATA_TYPES: 'FETCH_INTEREST_RATES_DATA_TYPES',
};

export const ycrAssetType = {
    FETCH_INTEREST_RATES_DATA_TYPES_ASSET: 'FETCH_INTEREST_RATES_DATA_TYPES_ASSET',
    FETCH_INTEREST_RATES_DATA_TYPES_DETAILS_ASSET: 'FETCH_INTEREST_RATES_DATA_TYPES_DETAILS_ASSET',
};

export const assetValueType = {
    FETCH_ASSET_VALUE: 'FETCH_ASSET_VALUE',
    FETCH_ASSET_DETAILS_VALUE: 'FETCH_ASSET_DETAILS_VALUE',
};

export const assetType = {
    ADD_ASSET: 'ADD_ASSET',
};


export const toastifyType = {
    SHOW_TOAST: 'SHOW_TOAST',
    SHOW_SUCCESS_MESSAGE: 'SHOW_SUCCESS_MESSAGE',
    SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE'
}


export const userActionType = {
    FETCH_USERS: "FETCH_USERS",
}
export const AdminUserActionType = {
    FETCH_USERS: 'FETCH_USERS',
    FETCH_USER: 'FETCH_USER',
    ADD_USER: 'ADD_USER',
    UPDATE_USER: 'UPDATE_USER',
    DELETE_USER: 'DELETE_USER',
    VERIFY_USER: 'VERIFY_USER',
};

export const constants = {
    SET_TOTAL_RECORD: 'SET_TOTAL_RECORD',
    IS_LOADING: 'IS_LOADING',
    IS_UPDATE_STATE: 'IS_UPDATE_STATE',
    IS_META: 'IS_META'
};


export const toastTypes = {
    SHOW_TOAST: 'SHOW_TOAST',
    SHOW_SUCCESS_MESSAGE: 'SHOW_SUCCESS_MESSAGE',
    SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE'
}

export const errorMessage = {
    TOKEN_NOT_PROVIDED: 'Token not provided',
    TOKEN_EXPIRED: 'Token has expired',
    TOKEN_INVALID_AUTH: 'Invalid authentication Token',
    TOKEN_INVALID: 'Could not decode token: Error while decoding to JSON: Syntax error',
    TOKEN_INVALID_SIGNATURE: 'Token Signature could not be verified.',
    NOT_AUTHENTICATED: 'Not Authenticated.'
};

export const profileActionType = {
    GET_PROFILE_INFO: 'GET_PROFILE_INFO',
    CHANGE_PROFILE_PASSWORD: 'CHANGE_PROFILE_PASSWORD'
}

export const Filters = {
    PAGE: 1,
    OBJ: {
        totalRecords: 0,
        totalPages: 0,
        page: 1,
        perPage: 10,
        direction: 'asc',
        search: '',
        adminName: 'admin',
        categoryId: '',
        created_at: 'created_at',
        status: '',
        payment_status: '',
        payment_type: '',
        product_unit: '',
        base_unit: ''
    }
};